###
  Colorpicker widget
###

class INTENT.widgets.ColorPicker

  @ATTR_NAME: "data-widget-colorpicker"

  constructor: (@el) ->
    @s = @.constructor
    # alert 'hello'

    @el.colorpicker @get_options()

  get_options: () ->
    {}